// extracted by mini-css-extract-plugin
export default {"row":"layout_row_x","expand":"layout_row_expand"};